import {_, React, classNames, withStyles, StyledProps, classObserver, observer, Fragment} from '@api'
import {ImageWrapperDefinition} from '@api/graphql'
import { useCatalog, WorkspaceConfig} from '@stores'

export interface IDataMapped {
  title?: /*{ name: string, isVisible: boolean } |*/ string | any
  subtitle1?: /*{ name: string, isVisible: boolean } |*/ string | any
  subtitle2?: string
  subtitle3?: string
  hex?: string
  images?: ImageWrapperDefinition[]
}

interface MyProps extends StyledProps {
  data?: any
  config?: any
  nullValue?: string
  children?: React.ReactNode | ((mapped: IDataMapped) => React.ReactNode)
  workspace?: Partial<WorkspaceConfig>
}

/**
 * Takes a datamap and an input object and _.gets() the various fields out to pass to any react children
 *
 * Leave as class for ref passing on tooltips
 */
export const DataMapper = observer<MyProps>(function DataMapper({data, config, children, nullValue, workspace}, ref) {
  const catalog = useCatalog(), {stores: {es}} = catalog

  let childrenWithProps = null
  if (config) {
    const keys = Object.keys(config)
    let mappedData = {...data}
    for (let key of keys) {
      mappedData[key] = _.isString(config[key]) ? es.readField(data, config[key]).val : null
      if (workspace && key === 'images') {
        if (_.isString(mappedData[key])) {
          mappedData[key] = [{exId: mappedData[key]}]
        }
        else if (!mappedData[key]) {
          mappedData[key] = catalog.imagesForCatalogItem({data, selectedImageSource: _.first(workspace.catalog?.imageSources)})
        }
      }

      if (mappedData[key] === '') {
        mappedData[key] = key != 'hex' ? nullValue : mappedData[key]
      } else if (mappedData[key] == null) {
        mappedData[key] = _.includes(['title', 'subtitle1', 'subtitle2', 'subtitle3'], key) ? nullValue : null
      }
    }

    if (_.isFunction(children)) {
      return <Fragment>{children(mappedData)}</Fragment>
    }

    let cardProps = {
      data: mappedData,
      dataMap: config
    }
    childrenWithProps = React.Children.map(children, (child: React.ReactElement<any>) => React.cloneElement(child, cardProps))
  }

  return <Fragment>{childrenWithProps}</Fragment>
}, {forwardRef: true})



// WEBPACK FOOTER //
// ./src/shared/components/ui/misc/DataMapper.tsx